import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Meetingph from "../../assets/pic/meeting.jpg"
import {Helmet} from "react-helmet";

const Meeting = ()=>{
    return(
        <div className='meeting-wrap'>
            <Helmet>
                <title>جلسه آنلاین</title>
                <meta name="description" content="مهمترین مزیت جلسه آنلاین، عدم نیاز به یک مکان خاص جهت گردهمایی است. همین امر باعث کاهش رفت و آمد‌ها شده که خود منجر کاهش هزینه‌ها و صرفه‌جویی در زمان می‌شود." />
            </Helmet>
            <Nav/>
            <div className='webinar-dec'>
                <h1>برگزاری جلسات و انجمن ها</h1>
                <img src={Meetingph} alt="جلسه آنلاین"/>
                <p>
                    برگزاری جلسات به صورت مجازی (وب کنفرانس) مزیت‌های بسیار زیادی دارد. می‌توان گفت که مهمترین مزیت آن، عدم نیاز به یک مکان خاص جهت گردهمایی است. همین امر باعث کاهش رفت و آمد‌ها شده که خود منجر کاهش هزینه‌ها و صرفه‌جویی در زمان می‌شود.
                </p>
                <p>
                    به عنوان مثال فرض کنید که دو انجمن علمی در دو دانشگاه متفاوت در دو شهر متفاوت، نیاز به مشورت و همکاری با یکدیگر داشته باشند. تعیین زمان و مکان مناسب برای یک جلسه و هماهنگی با تمامی افراد می‌تواند یکی از چالش‌های اصلی پیش رو برای این کار باشد. اما با برگزاری جلسه به صورت آنلاین (مجازی) در پلتفرم‌هایی که ابزارهای تعاملی لازم و استاندارد را دارا می‌باشند، به راحتی می‌توانید جلسات خود را با بازدهی بالا برگزار کنید.
                </p>
                <p>
                    فعالیت به صورت مجازی (آنلاین)، جامعه آماری و دنیای بزرگ‌تری را پیش روی شما قرار می‌دهد. به عنوان مثال  برون سپاری پروژه‌ها به افراد حائز شرایطی که در سایر شهرها یا حتی سایر کشورها هستند. با توجه به نتایج تحقیقات و مطالعات اجتماعی در حوزه کار و فناوری، تمایل افراد به انجام دورکاری (چه کارفرما و چه کارمند) روز به روز بیشتر می‌شود.
                </p>
                <p>
                    این افزایش تمایل خود مدیون پیشرفت تکنولوژی‌های ارتباطی و به تکامل رسیدن پلتفرم‌های برگزاری جلسات مجازی است. امروزه پلتفرم‌های برگزاری جلسات مجازی دارای کامل‌ترین ابزارهای تعاملی هستند که حتی می‌توانند بازدهی بیشتری از جلسات حضوری به ارمغان بیاورند.
                </p>
                <p>
                    ابزارهای تعاملی استاندارد در یک پلتفرم جامعه برگزاری جلسات آنلاین به قرار زیر است:
                </p>
                <ul>
                    <li>•	تعامل صوتی با کیفیت بالا</li>
                    <li>•	تعامل تصویری با کیفیت بالا با امکان برقراری چندین ارتباط تصویری</li>
                    <li>•	گفتگو و تعامل متنی (چت)</li>
                    <li>•	پخش ویدیو آنلاین</li>
                    <li>•	به اشتراک گذاری فایل</li>
                    <li>•	به اشتراک گذاری محتوای صفحه نمایش</li>
                    <li>•	و امکان ایجاد نمایش پیام یا اعلانات مهم به صورت دوره‌ای در محیط جلسه</li>
                </ul>
                <p>
                    پلتفرم جامع برگزاری جلسات مجازی BellMeet، تنها پتلفرم بومی و دانش بنیان با کامل‌ترین ابزار‌های تعاملی که در فوق نیز ذکر شد، آماده میزبانی بستر جلسات و گردهمایی های آنلاین شما است تا تجربه‌ای دلنشین و کارآمدتر از جلسات حضوری داشته باشید.
                </p>
            </div>
            <Footer/>
        </div>
    )
}

export default Meeting